// extracted by mini-css-extract-plugin
export default {"body_only":"TableBody_body_only__FiQQc","default_body":"TableBody_default_body__6vxzK","single_row":"TableBody_single_row__Vodpp","fadeInOut":"TableBody_fadeInOut__sD+Oa"};